function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMessageBanki = function SvgMessageBanki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M9.7 15.31v1.686c0 .758.616 1.374 1.374 1.374h6.143l2.346 1.876a.7.7 0 0 0 .74.084.7.7 0 0 0 .397-.63v-8.938c0-.758-.616-1.374-1.374-1.374H17.5V5.399A1.6 1.6 0 0 0 15.901 3.8H4.899A1.6 1.6 0 0 0 3.3 5.399v11.916a.7.7 0 0 0 1.137.547l3.192-2.552zm9.6-4.522v7.455l-1.4-1.119a.7.7 0 0 0-.437-.154H11.1v-6.182zm-3.2-1.4V5.399a.2.2 0 0 0-.199-.199H4.899a.2.2 0 0 0-.199.199v10.46l2.246-1.796a.7.7 0 0 1 .437-.153H9.7v-3.148c0-.758.616-1.374 1.374-1.374z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessageBanki);
export default ForwardRef;